import { Link } from "react-router-dom";
import { ArrowUpRight, Users, ChartLineUp, Calendar } from "@phosphor-icons/react";

/**
 * Final call-to-action block at the bottom of the Sacrifice / Legacy Challenge
 * page. Self-contained — no state, no props.
 */
export default function SacrificeFinalCTA() {
  return (
    <section data-testid="sacrifice-final-cta" className="px-4 md:px-8 py-20 md:py-32 max-w-3xl mx-auto text-center border-t border-white/10">
      <Users size={28} weight="fill" className="text-[#B32027] mx-auto mb-6" />
      <p className="font-serif italic text-white/80 text-xl md:text-2xl leading-relaxed space-y-1">
        This is more than a fitness challenge.<br />
        It is a tribute.<br />It is a reminder.<br />It is a legacy.<br />
        It is a way to move with purpose.
      </p>
      <h2 className="mt-12 font-display font-black uppercase tracking-tighter leading-[0.85] text-4xl md:text-7xl">
        911 minutes.<br />
        One month.<br />
        <span className="text-[#B32027]">One legacy.</span>
      </h2>
      <p className="mt-10 font-brush text-4xl md:text-6xl text-white -rotate-2">Who are you moving for?</p>
      <div className="mt-12 flex flex-wrap justify-center gap-4">
        <a
          href="#legacy-signup"
          data-testid="final-cta-join"
          onClick={(e) => { e.preventDefault(); document.getElementById("legacy-signup")?.scrollIntoView({ behavior: "smooth", block: "start" }); }}
          className="inline-flex items-center gap-3 bg-[#B32027] hover:bg-[#D42730] text-white px-10 py-5 text-[11px] font-bold uppercase tracking-[0.3em]"
        >
          Join the Legacy Challenge <ArrowUpRight size={14} weight="bold" />
        </a>
        <Link to="/sweat-for-sacrifice/log" className="inline-flex items-center gap-3 border-2 border-white/30 hover:border-[#B32027] text-white px-10 py-5 text-[11px] font-bold uppercase tracking-[0.3em]">
          Log Minutes <ChartLineUp size={14} weight="bold" />
        </Link>
      </div>

      <p className="mt-12 text-white/40 text-[11px] uppercase tracking-[0.3em] font-semibold flex items-center justify-center gap-2 flex-wrap">
        <Calendar size={12} weight="fill" /> Annual · Every September · Sweat With Slay
      </p>
    </section>
  );
}
